import NavDropdown from "./NavDropdown";

export default function DosenNavbar() {
  const jadwalDropdownItems = [
    ["Jadwal Pribadi", "/dosen/jadwal-pribadi"],
    ["Jadwal Sidang", "/jadwal-sidang"],
  ];

  return <NavDropdown label="Jadwal" dropdownItems={jadwalDropdownItems} />;
}
